import './StylishLoader.scss';

import { Box, Typography } from '@mui/material';
import React from 'react';

interface StylishLoaderProps {
  text?: string;
  fullPage?: boolean;
  mode?: 'full-page' | 'inline' | 'table' | 'button';
  className?: string;
}

const StylishLoader: React.FC<StylishLoaderProps> = ({
  text = 'Loading...',
  fullPage = true,
  mode,
  className,
}) => {
  // Determine the mode to use
  const loaderMode = mode || (fullPage ? 'full-page' : 'inline');

  return (
    <Box className={`stylish-loader-container ${loaderMode} ${className}`}>
      <Box className="loader-spinner" />
      <Typography className="loading-text">{text}</Typography>
    </Box>
  );
};

export default StylishLoader;
